import React, { useEffect, useCallback } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AnimatedRoutes from "./AnimatedRoutes";
import "./App.css";
import { InactivityTimerService } from "./services/InactivityTimerService";
import RouteTitle from "./shared/components/RouteTitle";

const AppComponent: React.FC = () => {
  const { i18n } = useTranslation();

  // Initialize the default language
  useEffect(() => {
    const defaultLang = localStorage.getItem("lang") || "en";
    try {
      i18n.changeLanguage(defaultLang);
    } catch (error) {
      console.error("Error switching language:", error);
    }
    localStorage.setItem("lang", defaultLang);
  }, [i18n]);

  // Refresh user activity
  const refreshUserActivity = useCallback(() => {
    InactivityTimerService.refreshUserActivity();
  }, []);

  // Setup activity listeners
  useEffect(() => {
    const events = ["mousemove", "click", "keypress"];
    events.forEach((event) =>
      document.addEventListener(event, refreshUserActivity)
    );

    return () => {
      events.forEach((event) =>
        document.removeEventListener(event, refreshUserActivity)
      );
    };
  }, [refreshUserActivity]);

  return (
    <Router>
      <RouteTitle />
      <AnimatedRoutes />
    </Router>
  );
};

export default AppComponent;
